import type { ReactNode } from "react";

/**
 * O cabeçalho de toda tela da Administração (2026-10-15): o selo
 * "Administração", o título da seção, uma frase do que ela faz e, à direita, as
 * ações da tela. Até aqui cada uma das nove telas montava o seu de um jeito
 * (título como selo pequeno, `h1` com botão de voltar, `h2` grande) e nenhuma
 * batia com a outra.
 */
export function AdminPageHeader({
  title,
  description,
  actions
}: {
  title: string;
  description: ReactNode;
  actions?: ReactNode;
}) {
  return (
    // `panel-header` dentro de um `ajustes-panel`: o mesmo cabeçalho de
    // Configurações e de Ajustes (o selo "Administração" vem do CSS).
    <header className="panel-header admin-page-header">
      <div>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
      {actions && <div className="admin-page-actions">{actions}</div>}
    </header>
  );
}
